import React from 'react'
import styled from 'react-emotion'

const WhistleForm = styled.div`
  padding: 2rem 0 4rem;
  h2, h4 {
    text-align: center;
    max-width: 500px;
    margin: 0.5em auto;
    font-weight: 500;
  }
`

const queryFill = params => {
  return params.substring(1).replace('-', ' ')
}

class Schedule extends React.Component {
  componentDidMount() {
    const script = document.createElement("script");

    script.id = 'hs-meetings-embed'
    script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js'
    script.async = true;
    script.defer = true

    document.body.appendChild(script);
  }

  render() {
    return (
      <WhistleForm>
        <div className="meetings-iframe-container" data-src="https://meetings.hubspot.com/jrojas3/demo?embed=true"></div>
      </WhistleForm>
    )
  }
}
 
export default Schedule;


// WEBPACK FOOTER //
// ./src/pages/schedule.js